<template>
  <div :class="$style.container">
    <MyBankCard v-if="activeNo === 0" @changeNo="handleChangeNo"/>
    <AddBankCard v-else-if="activeNo === 1" @changeNo="handleChangeNo"/>
    <CardDetail v-else-if="activeNo === 2" @changeNo="handleChangeNo" :info="bankInfo"/>
  </div>
</template>
<script>
import MyBankCard from './my-bank-card'
import AddBankCard from './addCard'
import CardDetail from './cardDetail'
export default {
  data() {
    return {
      activeNo: 0,
      bankInfo: {}
    };
  },
  components: {
    MyBankCard,
    AddBankCard,
    CardDetail
  },
  methods: {
    handleChangeNo (num, obj= {}) {
      this.activeNo = num
      this.bankInfo = obj
    }
  }
};
</script> 
<style lang="less" module>
.container {
}
</style>